import FileSize from "../../../../components/commonComponent/FileSize";
import React, { useState } from "react";
import { PdfPreviewModal } from "./PdfDocumentTable";
import budgetPdf from "../../../../assets/rti_pdf/Budget-2024-25pdf-311abaa56a3792f4afe9e61db2fe4837.pdf";

const budgetDocument = {
  title: "Budget for F.Y. 2024-2025",
  fileName: "Budget-2024-25pdf-311abaa56a3792f4afe9e61db2fe4837.pdf",
  href: budgetPdf,
};

const PdfBadge = () => (
  <span className="relative inline-block h-[15px] w-[13px] shrink-0 rounded-[2px] bg-[#e0e5ea] align-middle shadow-[0_1px_1px_rgba(0,0,0,0.18)]">
    <span className="absolute right-0 top-0 h-0 w-0 border-b-[5px] border-l-[5px] border-b-[#c5ced7] border-l-transparent" />
    <span className="absolute left-1/2 top-[7px] -translate-x-1/2 rounded-[1px] bg-[#ff5145] px-[2px] text-[5px] font-bold leading-[7px] text-white">
      PDF
    </span>
  </span>
);

const ChapterTwelveContent = () => {
  const [selectedDocument, setSelectedDocument] = useState(null);

  return (
    <>
      <article className="min-w-0 flex-1 px-1 pb-8 font-sans text-[14px] leading-7 text-[#123764]">
        <h2 className="mb-12 max-w-[900px] text-[20px] font-bold leading-7 text-[#006461]">
          Chapter 12 : Budget allocated, plans, proposed expenditures and
          reports on disbursement made [SECTION 4(1)(B)(xi)]
        </h2>

        <p>
          <span>Budget for F.Y. 2024-2025:</span>
          <button
            type="button"
            onClick={() => setSelectedDocument(budgetDocument)}
            className="ml-2 inline-flex items-center gap-2 bg-transparent p-0 text-[#123764] underline underline-offset-2 hover:text-[#0f8a7e] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#0f8a7e] focus-visible:ring-offset-2"
          >
            Click here to open
            <PdfBadge /><FileSize href={budgetDocument.href} fileName={budgetDocument.fileName} />


          </button>
        </p>
      </article>

      {selectedDocument && (
        <PdfPreviewModal
          pdfDocument={selectedDocument}
          onClose={() => setSelectedDocument(null)}
        />
      )}
    </>
  );
};

export default ChapterTwelveContent;
